import { render, staticRenderFns } from "./login5.vue?vue&type=template&id=4a509993&scoped=true&"
import script from "./login5.vue?vue&type=script&lang=js&"
export * from "./login5.vue?vue&type=script&lang=js&"
import style0 from "./login5.vue?vue&type=style&index=0&id=4a509993&prod&lang=scss&"
import style1 from "./login5.vue?vue&type=style&index=1&id=4a509993&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a509993",
  null
  
)

export default component.exports